import React, { useEffect, useState } from 'react';
import { FaCog, FaTasks, FaWrench, FaExclamationTriangle, FaBolt, FaClock, FaRegClock, FaExclamationCircle } from "react-icons/fa";
import Card from 'react-bootstrap/Card';

import './SidePanel.css';

const SidePanel = (props) => {
    const [icon, setIcon] = useState();
    const formatCount = (value) => {
        const num = Number(value || 0);
        if (num >= 10000) {
            return `${(num / 1000).toFixed(1)}k`;
        }
        return num.toLocaleString();
    };

    useEffect(() =>{
        let img = null
        switch (props.img) {
            case 'cog': 
                img = <FaCog className="panelImg" aria-hidden="true" />
                break;
            case 'tasks': 
                img = <FaTasks className="panelImg" aria-hidden="true" />
                break;
            case 'wrench': 
                img = <FaWrench className="panelImg" aria-hidden="true" />
                break;
            case 'alert': 
                img = <FaExclamationTriangle className="panelImg" aria-hidden="true" />
                break;
            case 'flash': 
                img = <FaBolt className="panelImg" aria-hidden="true" />
                break;
            case 'clock': 
                img = <FaClock className="panelImg" aria-hidden="true" />
                break;
            default:
            
        }
        setIcon(img)
    },[props.img])

    const isTotal = Boolean(props.task_only || props.task_only === 0);
    const isIncident = props.bg === 'danger' || props.bg === 'warning' || props.bg === 'secondary';
    const weekValue = formatCount(props.task_month);
    const todayValue = formatCount(props.task_day);
    const totalValue = formatCount(props.task_only);
    const periodLabel = props.periodLabel || (isTotal ? 'Total' : 'Last 7 days');
    const todayLabel = props.todayLabel || 'today';
    const extraNote = props.extraNote || null;
    const ariaLabel = isTotal
        ? `${props.title}: ${totalValue} ${periodLabel}${extraNote ? `, ${extraNote}` : ''}`
        : `${props.title}: ${weekValue} ${periodLabel}, ${todayValue} ${todayLabel}${extraNote ? `, ${extraNote}` : ''}`;
    const todayIcon = isIncident
        ? <FaExclamationCircle className="panel-today-icon" aria-hidden="true" />
        : <FaRegClock className="panel-today-icon" aria-hidden="true" />;

    return (
        <div className="SidePanel" onClick={props.onClick} role="button" tabIndex={0} aria-label={ariaLabel} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') props.onClick(); }}>
            <Card className={`panel panel-${props.bg} panel-${props.size || 'lg'} ${isTotal ? 'panel-total' : 'panel-period'} ${isIncident ? 'panel-incident' : 'panel-ops'}`}>                   
                <Card.Body className="panel-body">
                    <div className="panel-head">
                        <div className="panel-title">{icon}<span>{props.title}</span></div>
                        <div className="panel-metric-label">{periodLabel}</div>
                    </div>
                    <div className="panel-top">
                        {isTotal ? (
                            extraNote ? <div className="panel-metric-extra">{extraNote}</div> : <span className="panel-metric-today-spacer" />
                        ) : (
                            <div className="panel-metric-today">{todayIcon}<span>{todayValue} {todayLabel}</span></div>
                        )}
                        <div className="panel-metric-value">{isTotal ? totalValue : weekValue}</div>
                    </div>
                </Card.Body>
            </Card>
        </div> 
    )
}
 
export default SidePanel;
